let isDirty = false;

export function setDirtyFlag(value) {
  isDirty = value;
}

export function getDirtyFlag() {
  return isDirty;
}

export function safeNavigate(navigateFn, to) {
  if (isDirty) {
    const ok = window.confirm('You have unsaved changes. Leave anyway?');
    if (!ok) return;
    isDirty = false; // Clear so useBlocker doesn't fire a second prompt
  }
  navigateFn(to);
}
